import { render, staticRenderFns } from "./ListaPrecantidades.vue?vue&type=template&id=03f545c3"
import script from "./ListaPrecantidades.vue?vue&type=script&lang=js"
export * from "./ListaPrecantidades.vue?vue&type=script&lang=js"
import style0 from "./ListaPrecantidades.vue?vue&type=style&index=0&id=03f545c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports